import { defineMessages } from 'react-intl';

const messages = defineMessages({
  saveThis: {
    id: 'components.SaveBookmarkButton.title',
    defaultMessage: 'Save this',
  },
  Article: {
    id: 'components.SaveBookmarkButton.article',
    defaultMessage: 'Article',
  },
  Product: {
    id: 'components.SaveBookmarkButton.product',
    defaultMessage: 'Product',
  }
});

export default messages;
